// extracted by mini-css-extract-plugin
export default {"checkout_page":"Cart_checkout_page__r9YG7"};